<template>
	<div
		class="widget-content"
		:style="{
			backgroundColor: widget.settings.bgColor,
			fontSize: `${widget.settings.fontSize}px`
		}"
		v-html="widget.settings.text"
	/>
</template>

<script>
export default {
    name: 'MarqueeView',
	props: {
		widget: Object
	}
}
</script>

<style lang="scss" scoped>
.widget {

	&-content {
		@include flex(flex, row, wrap, center, center);
		height: 100%;
		padding: 0 10%;
		width: 100%;
		height: 100%;
		line-height: 1.3;
		user-select: none;
	}

}
</style>
